import React, { useRef } from 'react';

export  function Carousel({ children }) {
  const ref = useRef(null);

  return (
    <div className="carousel-wrap">
      <div className="section-head">
        <h2>Featured Products</h2>
        <div className="controls">
          <button aria-label="Previous" onClick={() => ref.current?.scrollBy({ left: -280, behavior: 'smooth' })}>‹</button>
          <button aria-label="Next" onClick={() => ref.current?.scrollBy({ left: 280, behavior: 'smooth' })}>›</button>
        </div>
      </div>
      <div className="carousel" ref={ref} role="region" aria-label="Featured products">
        {children}
      </div>
      <style>{`
        .section-head{display:flex;align-items:center;justify-content:space-between;padding:16px 0}
        .controls button{height:36px;width:36px;border-radius:8px;border:1px solid var(--border);background:#fff}
        .carousel{display:grid;grid-auto-flow:column;grid-auto-columns:260px;gap:16px;overflow:auto;padding-bottom:8px;scroll-snap-type:x mandatory}
        .carousel > *{scroll-snap-align:start}
      `}</style>
    </div>
  );
}
